import { CompanyTitledPage } from "../../TitledPage";

import { SAMPLE_CUSTOMER_LIST, SAMPLE_CUSTOMER_SEND_GROUP_LIST, SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST, SAMPLE_CUSTOMER_SHOP_LIST } from "../../../common/SampleData";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";


import { CompanyPartHeader } from "../../../components/PartHeader";
import { useNavigate } from "react-router-dom";

import { useState } from "react";
import { OutlinedInput } from "@mui/material";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import CustomerSendGroupShopSelectPart from "../../../components/CustomerSendGroupShopSelectPart";

const getSelectingCustomerShopList = (customerShopList) => {
  return customerShopList.map((customerData) => ({
    customer_id: customerData.customer_id,
    customer_name: customerData.customer_name,
    selected_shop_list: customerData.shop_list.filter((shopData) => shopData.is_selected)
  }));
}

// 新規取引先送信グループ店舗登録
export default function CustomerSendGroupRegistrationPage() {
  
  const navigate = useNavigate()

  const getInitialCustomerShopList = () => (SAMPLE_CUSTOMER_LIST
    .filter((customerData) => customerData.delete_flag === 0)
    .map((customerData) => ({
      customer_id: customerData.customer_id,
      customer_name: customerData.name,
      shop_list: SAMPLE_CUSTOMER_SHOP_LIST
          .filter((shopData) => shopData.customer_id === customerData.customer_id && shopData.delete_flag === 0)
          .map((shopData) => ({
            shop_id: shopData.shop_id,
            shop_name: shopData.name,
            is_selected: false
          }))
    }))
  );


  const [customerSendGroupNameInput, setCustomerSendGroupNameInput] = useState("");

  const [customerShopList, setCustomerShopList] = useState(getInitialCustomerShopList());

  const handleFocusInput = (event) => {
    event.target.select();
  }

  const handleChangeCustomerSendGroupNameInput = (event) => {
    setCustomerSendGroupNameInput(event.target.value);
  }

  const onClickReturn = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_list");
  }

  const onClickConfirm = (event) => {

    let customerSendGroupId = (SAMPLE_CUSTOMER_SEND_GROUP_LIST.length + 1).toString().padStart(6, "0");

    SAMPLE_CUSTOMER_SEND_GROUP_LIST.push({
      customer_send_group_id: customerSendGroupId,
      name: customerSendGroupNameInput,
      delete_flag: false
    });

    getSelectingCustomerShopList(customerShopList).forEach((customerData) => {
      let customerId = customerData.customer_id;

      customerData.selected_shop_list.forEach((shopData) => {

        SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST.push({
          customer_send_group_id: customerSendGroupId,
          customer_id: customerId,
          shop_id: shopData.shop_id,
          delete_flag: false
        })
        
      })
    })

    navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_list");

  }

  return (
    <CompanyTitledPage title="新規取引先送信グループ登録">

      <Grid container spacing={2}>
        <Grid item xs></Grid>
        <Grid item xs='auto'>
          <Button variant="contained" onClick={onClickConfirm}>確定</Button>
        </Grid> 
        <Grid item xs='auto'>
          <Button variant="outlined" onClick={onClickReturn}>戻る</Button>
        </Grid>        
      </Grid>

      <Box marginTop={2}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs="auto">
            <Typography>
              グループ名
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <OutlinedInput
              onFocus={handleFocusInput} onChange={handleChangeCustomerSendGroupNameInput}
              value={customerSendGroupNameInput} 
              sx={{width: 400}}
            />
          </Grid>        
        </Grid>
      </Box>

      <CompanyPartHeader>        
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>店舗選択</Typography>
          </Grid>    
        </Grid>
      </CompanyPartHeader>
      
      <CustomerSendGroupShopSelectPart customerShopList={customerShopList} setCustomerShopList={setCustomerShopList} />
     
    </CompanyTitledPage>
  );
}
